var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CoreHelperUtil } from '@web3modal/core';
import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import styles from './styles.js';
let W3mMobileDownloadLinks = class W3mMobileDownloadLinks extends LitElement {
    constructor() {
        super(...arguments);
        this.wallet = undefined;
    }
    render() {
        if (!this.wallet) {
            this.style.display = 'none';
            return null;
        }
        const { app_store, play_store } = this.wallet;
        const isMobile = CoreHelperUtil.isMobile();
        const isIos = CoreHelperUtil.isIos();
        const isAndroid = CoreHelperUtil.isAndroid();
        if (app_store && play_store && !isMobile) {
            return html `
        <wui-separator></wui-separator>

        <wui-flex gap="xs">
          <wui-list-item
            variant="icon"
            icon="appStore"
            iconVariant="square"
            @click=${this.onAppStore.bind(this)}
          >
            <wui-text variant="paragraph-500" color="fg-100">App Store</wui-text>
          </wui-list-item>

          <wui-list-item
            variant="icon"
            icon="playStore"
            iconVariant="square"
            @click=${this.onPlayStore.bind(this)}
          >
            <wui-text variant="paragraph-500" color="fg-100">Play Store</wui-text>
          </wui-list-item>
        </wui-flex>
      `;
        }
        if (app_store && !isAndroid) {
            return html `
        <wui-separator></wui-separator>

        <wui-list-item
          variant="icon"
          icon="appStore"
          iconVariant="square"
          chevron
          @click=${this.onAppStore.bind(this)}
        >
          <wui-text variant="paragraph-500" color="fg-100">Get the app</wui-text>
        </wui-list-item>
      `;
        }
        if (play_store && !isIos) {
            return html `
        <wui-separator></wui-separator>

        <wui-list-item
          variant="icon"
          icon="playStore"
          iconVariant="square"
          chevron
          @click=${this.onPlayStore.bind(this)}
        >
          <wui-text variant="paragraph-500" color="fg-100">Get the app</wui-text>
        </wui-list-item>
      `;
        }
        this.style.display = 'none';
        return null;
    }
    onAppStore() {
        if (this.wallet?.app_store) {
            CoreHelperUtil.openHref(this.wallet.app_store, '_blank');
        }
    }
    onPlayStore() {
        if (this.wallet?.play_store) {
            CoreHelperUtil.openHref(this.wallet.play_store, '_blank');
        }
    }
};
W3mMobileDownloadLinks.styles = [styles];
__decorate([
    property({ type: Object })
], W3mMobileDownloadLinks.prototype, "wallet", void 0);
W3mMobileDownloadLinks = __decorate([
    customElement('w3m-mobile-download-links')
], W3mMobileDownloadLinks);
export { W3mMobileDownloadLinks };
//# sourceMappingURL=index.js.map